module.exports = __webpack_public_path__ + "img/get-inspired-dark.397e2a2b.svg";